import { useEffect, useState } from 'react';

const useQuantityDeliveryTabs = (parcels = []) => {
  const [parcelTabs, setParcelTabs] = useState({});

  useEffect(() => {
    const nextTabs = {};
    parcels.forEach(parcel => {
      nextTabs[parcel.id] = 'quantity';
    });
    setParcelTabs(nextTabs);
  }, [parcels]);

  const toggleParcelTab = (parcelId, tab) => {
    setParcelTabs(prev => ({ ...prev, [parcelId]: tab }));
  };

  return { parcelTabs, toggleParcelTab };
};

export default useQuantityDeliveryTabs;
